const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Sync = {
  postCSRF: (payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: '/web-2/cronofy/csrf/token',
      method: 'POST'
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  },
  fetchSyncStatusOneSpace: (spaceId, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/calendar/cronofy/space/${spaceId}/calendar/settings`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },
  fetchSyncStatusAllCal: (accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: '/v1/calendar/cronofy/user/calendars/status',
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },
  fetchCronofyCalendars: (spaceId, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/calendar/cronofy/space/${spaceId}/calendars`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },
  fetchCalendarStatus: (spaceId, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/calendar/cronofy/space/${spaceId}/calendar/status`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },
  updateSync: (path, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/calendar/cronofy/space/${path}`,
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  }
};
